import { Component } from '@angular/core';
import { AuthService } from './service/auth/auth.service';
import { LoadingService } from './service/common/loading.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent {
  isloggedIn : boolean = false;
  showLoading = false;
  constructor(
    public auth : AuthService,
    private loading : LoadingService,
  ) {
    
    
   }

  ngOnInit() : void {
    this.init();
    this.auth.isLoggedIn().subscribe(res => {
      this.isloggedIn = res;
    })
  } 

  init(){
    this.auth.checkLanding();
    this.loading.getSpinnerObserver().subscribe((status)=>{
      this.showLoading = status ==='start';
      // this.cdRef.detectChanges();
    })
    
  }

}
